'use strict';
const angular = require('angular');

export class textMessageFilterSendComponent {
  /*@ngInject*/
  constructor(TextMessagesService, SettingsService, CommunityService, PropertyService, DTOptionsBuilder, $uibModal) {

    this.SettingsService = SettingsService;
    this.TextMessagesService = TextMessagesService;
    this.CommunityService = CommunityService;
    this.PropertyService = PropertyService;
    this.$uibModal = $uibModal;

    this.filteredAvailableNumbers = [];

    this.availableNumbers = [];
    this.selectedNumbers = [];

    this.filterPrimaryOwner = true;
    this.filterOwner = true;
    this.filterTenant = false;
    this.filterSecondOwner = false;

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('order',  [0, 'asc']);

    this.CommunityService.query(data => {
      this.communities = [{
        value: undefined,
        name: '- All -'
      }].concat(data.map(cmty => {
        return {
          value: cmty._id,
          name: cmty.code + ": " + cmty.name
        };
      }));
    });

    this.PropertyService.queryWithContacts(data => {
      data.forEach(ppty => {
        ppty.contacts
          .filter(c => c.contact && c.contact.phone && c.contact.phone.length)
          .filter(c => c.type == 'primary-owner' || c.type == 'owner' || c.type == 'renter')
          .forEach(c => {
            c.contact.phone
              .filter(phone => ["mobile","cell"].includes(phone.type.toLowerCase()))
              .forEach(p => {
              let o = {
                firstName: c.contact.firstName,
                lastName: c.contact.lastName,
                middleName: c.contact.middleName,
                company: c.contact.company,
                community: ppty.community,
                lotNo: ppty.lotNo,
                buildingNo: ppty.buildingNo
              }

              o.type = {
                user: c.type,
                phone: p.isPrimary ? "primary-phone" : "other-phone"
              };

              o.address = (ppty.address && ppty.address.street) ? ppty.address.street : "-";
              o.phone = p.number;

              this.availableNumbers.push(o);

            })
          })
      })

      this.applyFilter();

      this.dataInitComplete = true;
    })

  }

  resetCommunityFilter() {
    this.community = undefined;
    this.applyFilter();
  }

  applyFilter() {
    this.filteredAvailableNumbers = this.availableNumbers;

    if (this.community) {
      this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(o => o.community == this.community)
    }

    if (!this.filterPrimaryOwner) {
      this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(o => o.type.user != 'primary-owner');
    }

    if (!this.filterOwner) {
      this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(o => o.type.user != 'owner');
    }

    if (!this.filterTenant) {
      this.filteredAvailableNumbers = this.filteredAvailableNumbers.filter(o => o.type.user != 'renter');
    }

  }

  selectNumber(number) {
    this.selectedNumbers.push(number);
    this.availableNumbers.forEach(o => {
      if (o.phone == number)
        o.selected = true;
    })
    this.filteredAvailableNumbers.forEach(o => {
      if (o.phone == number)
        o.selected = true;
    })
  }

  selectAllAvailable() {
    this.filteredAvailableNumbers.forEach(o => {
      o.selected = true;
      if (!this.selectedNumbers.includes(o.phone))
        this.selectedNumbers.push(o.phone);
    })
  }

  removeNumber(number) {
    this.selectedNumbers = this.selectedNumbers.filter(p => p != number);
    this.availableNumbers.forEach(o => {
      if (o.phone == number)
        o.selected = false;
    })
    this.filteredAvailableNumbers.forEach(o => {
      if (o.phone == number)
        o.selected = false;
    })
  }

  addIndividualNumber() {

    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'phoneNumberEditModal',
      size: 'sm'
    });

    modalInstance.result.then(
      function (number) {
        that.selectNumber(number);
      },
      function () { /* cancel */ }
    );

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    let textMessage = this.config.textMessage;

    textMessage.recipients = this.selectedNumbers.map(number => "+1" + number);

    this.TextMessagesService.send({id: textMessage._id}, textMessage, (res) => {
      this.close({$value: {testMessageId: textMessage._id}});
    }, (err) => {
      console.log("Could not send text message");
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.textMessageFilterSendComponent', [])
  .component('textMessageFilterSendComponent', {
    template: require('./text-message-filter-send.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: textMessageFilterSendComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/text-message-filter-send/text-message-filter-send.component.js